import { css } from 'emotion';

export const adaptiveText = css`
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  -webkit-font-smoothing: subpixel-antialiased;
  opacity: 1;
  transition: opacity 0.15s linear;
`;

export const hidden = css`
  visibility: hidden !important;
  opacity: 0;
`;

export const desktopAdaptiveText = css`
  font-family: 'Montserrat', sans-serif;
  line-height: normal;
`;
